/* eslint-disable max-lines */
import { useMemo } from 'react';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { AppointmentResource, AppointmentSchedule } from '~libs.shared.appointments-timetable';

import { useCancelledVisibilityPreferenceState } from '../shared/preferences/preferences.storage';

import { filterCancelledAppointmentEventsSlots } from './HealthcareLocationTimetable.utils';

type UseResourcesOptions = {
   practitioners: AppointmentPractitioner[];
   appointmentSchedules: AppointmentSchedule[] | null;
};

export const useResources = (options: UseResourcesOptions): AppointmentResource[] => {
   const [preferCancelledVisible] = useCancelledVisibilityPreferenceState();
   return useMemo((): AppointmentPractitioner[] => {
      if (!options.appointmentSchedules) {
         return options.practitioners;
      }

      const practitionersMap = new Map(
         options.practitioners.map((practitioner) => [practitioner.id.asNumber(), practitioner])
      );

      return options.appointmentSchedules.reduce<AppointmentPractitioner[]>((practitioners, schedule) => {
         const practitioner = practitionersMap.get(schedule.resourceId.asNumber());
         const eventSlotsLength = preferCancelledVisible
            ? schedule.eventsSlots.length
            : filterCancelledAppointmentEventsSlots(schedule.eventsSlots).length;

         const hasSlots = Boolean(eventSlotsLength || schedule.backgroundSlots?.length || schedule.hoverSlots.length);
         if (hasSlots && practitioner) {
            practitioners.push(practitioner);
         }

         return practitioners;
      }, []);
   }, [options.appointmentSchedules, options.practitioners, preferCancelledVisible]);
};
